import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AuthenticationService } from '@app/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent implements OnInit {
  isLoading: boolean;
  error: string;
  hash: string;
  message = '';

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authenticationService: AuthenticationService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];

      if (token) {
        debugger;
        console.log(token);
        this.authenticationService.verifyEmailKey(token).subscribe({
          next: (res: any) => {
            console.log(res);
            this.message = 'Your email is verified successfully.';
            setTimeout(() => this.router.navigate(['/select']), 2000);
          },
          error: err => {
            console.log(err);
            this.error = 'Invalid or expired verification link.';
          }
        });
      } else {
        this.error = 'No verification token provided.';
      }
    });
  }
}
